import { useHistory } from 'react-router-dom';

export const useFormRedirect = (form, requiredFields) => {
  const history = useHistory();
  const hasFields = requiredFields.every((field) => {
    const fieldValue = form.state[field];
    return fieldValue && fieldValue.value;
  });
  if (!hasFields) {
    history.push('/');
  }
  return hasFields;
};
